/**
 * Converts a Base64-encoded JSON string to a javascript object.
 *
 * @param str - a base64 string to decode
 */
const base64ToObject = (str) => {
  try {
    return str && JSON.parse(Buffer.from(str, 'base64').toString('ascii'));
  } catch (e) {
    // invalid json; do nothing
  }
};

export default base64ToObject;
